import { useState, useEffect } from 'react';

const Navbar = () => {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  const scrollTo = (href: string) => {
    const el = document.querySelector(href);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <header
      className={`fixed top-0 left-0 w-full z-50 transition-all duration-300 ${
        scrolled ? 'bg-[#060606]/95 backdrop-blur-md border-b border-white/5' : ''
      }`}
    >
      <div className="max-w-[1400px] mx-auto px-6 lg:px-14">
        <div className="flex items-center justify-between h-[160px]">

          {/* Logo */}
          <a
            href="#hero"
            onClick={(e) => { e.preventDefault(); scrollTo('#hero'); }}
            className="flex items-center cursor-pointer"
          >
            <img
              src="https://storage.readdy-site.link/project_files/84733ff0-c80f-453c-bb88-cea233922c90/07dce610-2d48-4487-af00-c98d564b8bed_surface-solutions-grey-logo-trans.png?v=7fff9acbc8304034587aa88e0c4fd1fe"
              alt="Surface Solutions of CT"
              className="h-40 w-auto object-contain"
            />
          </a>

          {/* CTA */}
          <a
            href="#contact"
            onClick={(e) => { e.preventDefault(); scrollTo('#contact'); }}
            className="px-5 py-2.5 bg-[#c9a84c] text-[#060606] text-[11px] font-black tracking-[0.14em] hover:bg-[#e0bf6a] transition-colors duration-200 whitespace-nowrap cursor-pointer"
          >
            REQUEST INFO
          </a>

        </div>
      </div>
    </header>
  );
};

export default Navbar;
